<template>
  <div>
    <h2 class="ViewHeading">Manual Temperature Checks</h2>
    <div>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-row>
        <b-col>
          <b-card-group deck
            ><b-card
              border-variant="info"
              header="Manual Temperature Checks for Review"
              header-bg-variant="info"
              align="center"
            >
              <b-card-text
                >You have {{ AmountForReview }} Manual Temperature Check(s) to
                be reviewed
              </b-card-text>

              <b-card-text></b-card-text> </b-card
            ><b-card
              border-variant="secondary"
              header="Upcoming Manual Temperature Checks"
              header-bg-variant="secondary"
              header-text-variant="light"
              align="center"
            >
              <b-card-text
                >You have {{ UpcomingChecks }} Manual Temperature Check(s) that
                are upcoming within the next 28 days
              </b-card-text>
            </b-card>
            <!-- <b-card
              border-variant="danger"
              header="Expired Manual Temperature Checks "
              header-bg-variant="danger"
              align="center"
            >
              <b-card-text
                >You have x Risk Assessment(s) that is overdue and
                expired</b-card-text
              >
              <b-card-text></b-card-text>
            </b-card> -->
          </b-card-group>
        </b-col>
      </b-row>
      <b-row><br /></b-row>
    </div>
    <div>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-tabs>
              <b-tab lazy>
                <template #title>
                  Check Results
                </template>

                <div id="Table">
                  <br />
                  <h4>Temp Check Results</h4>
                  <br />
                  <div>
                    <b-table
                      sticky-header
                      no-border-collapse
                      responsive
                      :items="CheckResultItems"
                      :fields="CheckResultFields"
                      show-empty
                      empty-text="You have no previous Temperature Checks"
                      hover
                      small
                    >
                      <template v-slot:cell(Details)="{ item }">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          v-on:click="viewDetails(item, 'New')"
                          >Show</b-button
                        >
                      </template>
                      <template v-slot:cell(HotTemp)="{ item }">
                        <p v-if="item.HotTemp != null">
                          {{ item.HotTemp }}&#8451;
                        </p>
                      </template>
                      <template v-slot:cell(ColdTemp)="{ item }">
                        <p v-if="item.ColdTemp != null">
                          {{ item.ColdTemp }}&#8451;
                        </p>
                      </template>
                      <template v-slot:cell(MixedTemp)="{ item }">
                        <p v-if="item.MixedTemp != null">
                          {{ item.MixedTemp }}&#8451;
                        </p>
                      </template>
                      <template v-slot:cell(ReturnTemp)="{ item }">
                        <p v-if="item.ReturnTemp != null">
                          {{ item.ReturnTemp }}&#8451;
                        </p>
                      </template>
                      <template v-slot:cell(Status)="{ item }">
                        <div v-if="item.Status === 'For Review'">
                          <b-badge variant="info">For Review</b-badge>
                        </div>
                        <div v-if="item.Status === 'New'">
                          <b-badge variant="secondary">New</b-badge>
                        </div>
                        <div v-if="item.Status === 'In Progress'">
                          <b-badge variant="light">In Progress</b-badge>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </b-tab>
              <b-tab lazy>
                <template #title>
                  Scheduled Checks
                </template>
                <div id="Table">
                  <br />
                  <h4>Scheduled Checks</h4>
                  <br />
                  <div>
                    <!-- {{ ScheduledCheckItems }} -->
                    <b-table
                      sticky-header
                      no-border-collapse
                      responsive
                      :items="ScheduledCheckItems"
                      :fields="ScheduledCheckFields"
                      show-empty
                      empty-text="You have no Temperature checks scheduled"
                      hover
                      small
                    >
                      <!-- <template v-slot:cell(Modify)="{ item }">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          v-on:click="modifyTempBooking(item)"
                          >{{ item.Modify }}</b-button
                        >
                      </template> -->
                      <template v-slot:cell(Modify)="{ item }">
                        <b-button
                          v-if="
                            item.Modify == 'FALSE' ||
                              item.Modify == '' ||
                              item.Modify == null
                          "
                          size="sm"
                          variant="outline-info"
                          v-on:click="modifyTempBooking(item)"
                          >Modify</b-button
                        >
                        <b-badge v-if="item.Modify == 'TRUE'"
                          >Under Edit</b-badge
                        >
                      </template>
                    </b-table>
                    <b-row>
                      <b-col class="text-left">
                        <b-button
                          variant="outline-secondary"
                          size="sm"
                          @click="showAddNewCheckModal()"
                        >
                          <BIconPlusSquare></BIconPlusSquare> Schedule New Check
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <template #title>
                  Completed Checks
                </template>
                <div id="Table">
                  <br />
                  <h4>Completed Checks</h4>
                  <br />
                  <div>
                    <b-table
                      sticky-header
                      no-border-collapse
                      responsive
                      :items="CheckCompletedResultItems"
                      :fields="CheckCompletedResultFields"
                      show-empty
                      empty-text="You have no Completed Temperature checks "
                      hover
                      small
                    >
                      <template v-slot:cell(Details)="{ item }">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          v-on:click="viewDetails(item, 'Completed')"
                          >Show</b-button
                        >
                      </template>
                      <template v-slot:cell(HotTemp)="{ item }">
                        <p v-if="item.HotTemp != null">
                          {{ item.HotTemp }}&#8451;
                        </p>
                      </template>
                      <template v-slot:cell(ColdTemp)="{ item }">
                        <p v-if="item.ColdTemp != null">
                          {{ item.ColdTemp }}&#8451;
                        </p>
                      </template>
                      <template v-slot:cell(MixedTemp)="{ item }">
                        <p v-if="item.MixedTemp != null">
                          {{ item.MixedTemp }}&#8451;
                        </p>
                      </template>
                      <template v-slot:cell(ReturnTemp)="{ item }">
                        <p v-if="item.ReturnTemp != null">
                          {{ item.ReturnTemp }}&#8451;
                        </p>
                      </template>
                      <template v-slot:cell(Modify)="{ item }">
                        <b-button
                          variant="outline-info"
                          v-on:click="modifyTempBooking(item)"
                          >Modify</b-button
                        >
                      </template>
                    </b-table>
                    <!-- <b-row>
                      <b-col cols="2">
                        <b-button
                          variant="outline-secondary"
                          size="sm"
                          @click="showAddNewCheckModal()"
                        >
                          <BIconPlusSquare></BIconPlusSquare> Schedule Check
                        </b-button>
                      </b-col>
                    </b-row> -->
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <b-modal
      ref="newTempBooking"
      id="newTempBooking"
      title="Test Booking"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      hide-footer
    >
      <b-card
        header-bg-variant="dark"
        border-variant="light"
        bg-variant="light"
      >
        <template #header>
          <h6 class="testHeader">
            Manual Temperature Check Request Form
          </h6>
        </template>
        <template #footer>
          <b-row>
            <b-col class="centered">
              <b-button
                variant="outline-info"
                small
                v-on:click="SubmitTempBooking()"
                >Submit</b-button
              >
              <b-button
                variant="outline-info"
                small
                v-on:click="ResetTempBooking()"
                >Reset</b-button
              >
            </b-col>
          </b-row>
        </template>
        <!-- <b-form-select :options="CheckType" v-model="newBooking.CheckType">
        </b-form-select> -->
        <h5 class="accessoriesHeader">Location Information</h5>

        <b-row>
          <!-- <b-col v-if="newBooking.CheckType == 'Single Outlet Check'">
            <b-form-input
              id="OutletID"
              v-model="newBooking.OutletID"
              placeholder="OutletID"
              required
            ></b-form-input>
          </b-col> -->
          <b-col>
            <b-form-input
              id="Area"
              v-model="newBooking.Room"
              placeholder="Room/Area"
              required
            ></b-form-input>
          </b-col>
          <b-col>
            <b-form-input
              id="LocationNote"
              v-model="newBooking.Note"
              placeholder="Location Note"
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <hr />
        <h5 class="accessoriesHeader">Check Information</h5>
        <b-row>
          <b-col>
            <h5 class="accessoriesHeader">Number of Outlets</h5>

            <b-form-input
              id="LocationNote"
              v-model="newBooking.Number"
              placeholder="No of Outlets"
              required
              type="number"
            ></b-form-input> </b-col
        ></b-row>
        <b-row>
          <b-col>
            <h5 class="accessoriesHeader">Date</h5>
            <b-form-datepicker
              id="input-4"
              v-model="newBooking.Date"
              class="mb-2"
            ></b-form-datepicker>
          </b-col>
          <b-col>
            <h5 class="accessoriesHeader">Time</h5>

            <b-form-timepicker
              locale="en"
              v-model="newBooking.Time"
              now-button
            ></b-form-timepicker>
          </b-col>
        </b-row>
        <hr />
        <h5 class="accessoriesHeader">Contact Information</h5>
        <b-row>
          <b-col>
            <b-form-input
              placeholder="Email Address"
              v-model="newBooking.Email"
            ></b-form-input>
          </b-col>
          <b-col>
            <b-form-input
              id="input-2"
              v-model="newBooking.Name"
              placeholder="Enter name"
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-input
              id="input-2"
              v-model="newBooking.ContactNote"
              placeholder="Note for Contact"
              required
              max="150"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
    <b-modal
      ref="ModifyTempBookingModal"
      id="ModifyTempBookingModal"
      title="Temp Check Booking"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      hide-footer
    >
      <b-card>
        <b-row class="mt-2">
          <b-col cols="4" class="modify-text-left">Service ID</b-col>

          <b-col cols="8">
            {{ ModifiedBooking.ServiceID }}
          </b-col>
        </b-row>
        <b-row class="mt-2"
          ><b-col cols="4" class="modify-text-left">Check Location</b-col>
          <b-col cols="8">
            {{ this.selectedlocation }}
          </b-col>
        </b-row>
        <b-row class="mt-2"
          ><b-col cols="4" class="modify-text-left">Room/Area</b-col>
          <b-col cols="8">
            {{ ModifiedBooking.Area }}
          </b-col>
        </b-row>
        <b-row class="mt-2"
          ><b-col cols="4" class="modify-text-left">Description</b-col>
          <b-col cols="8">{{ ModifiedBooking.Description }} </b-col>
        </b-row>
        <b-row class="mt-2"
          ><b-col cols="4" class="modify-text-left">Test Type</b-col>
          <b-col cols="8">{{ ModifiedBooking.Type }} </b-col>
        </b-row>
        <b-row class="mt-2"
          ><b-col cols="4" class="modify-text-left">Arranged By</b-col>
          <b-col cols="8">
            {{ ModifiedBooking.ArrangedBy }}
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col class="boldLabel"
            >Scheduled Date:
            <b-form-datepicker
              locale="en"
              :placeholder="this.ModifiedBooking.Date"
              v-model="ModifiedBooking.Date"
            ></b-form-datepicker
          ></b-col>
        </b-row>
        <b-row>
          <b-col class="boldLabel"
            >Scheduled Time:
            <b-form-timepicker
              locale="en"
              :placeholder="this.ModifiedBooking.Time"
              v-model="ModifiedBooking.Time"
              now-button
            ></b-form-timepicker
          ></b-col>
        </b-row>
        <b-row
          ><b-col><br /></b-col
        ></b-row>
        <b-row>
          <b-col
            ><b-button
              variant="outline-info"
              v-on:click="SubmitModifiedBooking()"
              >Submit Changes</b-button
            ></b-col
          >
          <b-col
            ><b-button
              variant="outline-info"
              v-on:click="CancelModifiedBooking()"
              >Cancel Changes</b-button
            ></b-col
          >
        </b-row>
        <b-row
          ><b-col><br /></b-col
        ></b-row>
      </b-card>
    </b-modal>
    <b-modal
      ref="TempDetailsModal"
      id="TempDetailsModal"
      title="Manual Temp Check Details"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
    >
      <b-card>
        <br />
        <b-row>
          <b-col><label class="boldLabel">Outlet ID</label></b-col>
          <b-col><label class="boldLabel">Taken By</label></b-col>
        </b-row>
        <b-row>
          <b-col>{{ this.detailItem.OutletID }}</b-col>
          <b-col>{{ this.detailItem.TakenBy }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10"><label class="boldLabel">Sample Date</label></b-col>
          <b-col cols="1"></b-col>
        </b-row>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <b-form-datepicker
              disabled
              :placeholder="this.detailItem.ReadingDate"
            ></b-form-datepicker>
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10"><label class="boldLabel">Sample Time</label></b-col>
          <b-col cols="1"></b-col>
        </b-row>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <b-form-timepicker
              disabled
              :placeholder="this.detailItem.ReadingTime"
              now-button
              locale="en"
            >
            </b-form-timepicker>
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
        <br />
      </b-card>
      <b-card-group>
        <b-card>
          <template #header
            >Hot Temp
            <b-avatar class="hoticon" v-b-tooltip.hover title="Hot Temp"
              ><BIconDropletHalf></BIconDropletHalf></b-avatar
          ></template>
          <p v-if="this.detailItem.HotTemp != null">
            {{ this.detailItem.HotTemp }}&#8451;
          </p>
          <p v-if="this.detailItem.HotTemp == null">Not Taken</p>
        </b-card>
        <b-card>
          <template #header
            >Cold Temp
            <b-avatar class="coldicon" v-b-tooltip.hover title="Cold Temp"
              ><BIconDropletHalf></BIconDropletHalf></b-avatar
          ></template>
          <p v-if="this.detailItem.ColdTemp != null">
            {{ this.detailItem.ColdTemp }}&#8451;
          </p>
          <p v-if="this.detailItem.ColdTemp == null">Not Taken</p>
        </b-card>
      </b-card-group>
      <b-card-group>
        <b-card>
          <template #header
            >Mixed Temp
            <b-avatar class="mixedicon" v-b-tooltip.hover title="Mixed Temp"
              ><BIconDropletHalf></BIconDropletHalf></b-avatar
          ></template>
          <p v-if="this.detailItem.MixedTemp != null">
            {{ this.detailItem.MixedTemp }}&#8451;
          </p>
          <p v-if="this.detailItem.MixedTemp == null">Not Taken</p>
        </b-card>
        <b-card>
          <template #header
            >Return Temp
            <b-avatar class="returnicon" v-b-tooltip.hover title="Return Temp"
              >R</b-avatar
            ></template
          >
          <p v-if="this.detailItem.ReturnTemp != null">
            {{ this.detailItem.ReturnTemp }}&#8451;
          </p>
          <p v-if="this.detailItem.ReturnTemp == null">Not Taken</p>
        </b-card>
      </b-card-group>
      <br />

      <b-row v-if="this.checkStatus == 'New'"
        ><b-col>
          <b-button variant="outline-info" v-on:click="acknowledgeTemps()">
            Acknowledge
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import {
  BIconDropletHalf,
  BIconPlusSquare,
} from "bootstrap-vue/dist/bootstrap-vue.esm";

export default {
  props: [],

  computed: {},
  components: {
    BIconDropletHalf,
    BIconPlusSquare,
  },

  data() {
    return {
      AmountForReview: null,
      UpcomingChecks: null,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      modifyItem: [],
      detailItem: [],
      ScheduledCheckFields: [
        { key: "ServiceID", label: "Service ID", variant: "primary" },
        // { key: "EndpointID", label: "Outlets" },
        { key: "Type", label: "Type" },
        { key: "Category", label: "Category" },
        { key: "ServiceNote", label: "Service Note" },
        { key: "DeptFloor", label: "Room Area" },
        { key: "Position", label: "Position" },
        { key: "LocationNote", label: "Location Note" },
        { key: "ArrangedBy", label: "Arranged By" },
        { key: "ScheduledDate", label: "Scheduled Date" },
        { key: "ScheduledTime", label: "Scheduled Time" },
        { key: "AssignedTo", label: "Assigned To" },
        { key: "Modify", label: "Modify" },
      ],
      ScheduledCheckItems: [],
      CheckResultFields: [
        { key: "CheckID", label: "CheckID", variant: "primary" },
        // { key: "OutletID", label: "Outlet" },
        { key: "ReadingDate", label: "Reading Date" },
        { key: "ReadingTime", label: "Time" },
        { key: "TakenBy", label: "Taken By" },
        { key: "HotTemp", label: "Hot Temp" },
        { key: "ColdTemp", label: "Cold Temp" },
        { key: "MixedTemp", label: "Mixed Temp" },
        { key: "ReturnTemp", label: "Return Temp" },
        { key: "Status", label: "Status" },
        { key: "Details", label: "Details" },
      ],
      CheckResultItems: [],
      CheckType: [
        { text: "Single or Full room", value: null, disabled: true },
        "Full Room Check",
        "Single Outlet Check",
      ],
      newBooking: {
        OutletID: null,
        Room: null,
        Note: null,
        CheckType: null,
        Name: null,
        Type: null,
        Date: null,
        Email: null,
        Time: null,
        Number: null,
      },
      ModifiedBooking: {
        ServiceID: null,
        Area: null,
        Description: null,
        Type: null,
        ArrangedBy: null,
        Date: null,
        Time: null,
      },
      CheckCompletedResultItems: [],
      CheckCompletedResultFields: [
        { key: "CheckID", label: "CheckID", variant: "primary" },
        { key: "OutletID", label: "Outlet" },
        { key: "ReadingDate", label: "Reading Date" },
        { key: "ReadingTime", label: "Time" },
        { key: "TakenBy", label: "Taken By" },
        { key: "HotTemp", label: "Hot Temp" },
        { key: "ColdTemp", label: "Cold Temp" },
        { key: "MixedTemp", label: "Mixed Temp" },
        { key: "ReturnTemp", label: "Return Temp" },
        { key: "Details", label: "Details" },
      ],
      checkStatus: "",
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/outlets";
    let LookUpHeaders = this.$apikeyPost;
    let LookUpRequest = {
      RequestType: "LoadManualTempChecksLocation",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios.post(LookUpUrl, LookUpRequest, LookUpHeaders).then((response) => {
      let CheckResultArray = response.data.Values;
      for (let i = 0; i < CheckResultArray.length; i++) {
        this.CheckResultItems.push({
          CheckID: CheckResultArray[i][0],
          OutletID: CheckResultArray[i][1],
          ReadingDate: CheckResultArray[i][2],
          ReadingTime: CheckResultArray[i][3],
          TakenBy: CheckResultArray[i][4],
          HotTemp: CheckResultArray[i][5],
          ColdTemp: CheckResultArray[i][6],
          MixedTemp: CheckResultArray[i][7],
          ReturnTemp: CheckResultArray[i][8],
          Status: CheckResultArray[i][9],
          Details: "",
        });
      }
    });

    let LookUpUrlCount =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/outlets";
    let LookUpHeadersCount = this.$apikeyPost;
    let LookUpRequestCount = {
      RequestType: "ManualTempCounts",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpUrlCount, LookUpRequestCount, LookUpHeadersCount)
      .then((response) => {
        this.AmountForReview = response.data.Values.ForReview;
        this.UpcomingChecks = response.data.Values.Scheduled;
      });

    let LookUpUrlComp =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/outlets";
    let LookUpHeadersComp = this.$apikeyPost;
    let LookUpRequestComp = {
      RequestType: "LoadCompletedManualTempChecks",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpUrlComp, LookUpRequestComp, LookUpHeadersComp)
      .then((response) => {
        let CheckResultArray = response.data.Values;
        for (let i = 0; i < CheckResultArray.length; i++) {
          this.CheckCompletedResultItems.push({
            CheckID: CheckResultArray[i][0],
            OutletID: CheckResultArray[i][1],
            ReadingDate: CheckResultArray[i][2],
            ReadingTime: CheckResultArray[i][3],
            TakenBy: CheckResultArray[i][4],
            HotTemp: CheckResultArray[i][5],
            ColdTemp: CheckResultArray[i][6],
            MixedTemp: CheckResultArray[i][7],
            ReturnTemp: CheckResultArray[i][8],
            Details: "",
          });
        }
      });

    let LookUpUrl2 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/outlets";
    let LookUpHeaders2 = this.$apikeyPost;
    let LookUpRequest2 = {
      RequestType: "LoadScheduledManualTempChecks",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios.post(LookUpUrl2, LookUpRequest2, LookUpHeaders2).then((response) => {
      let checksArray = response.data.Values;

      for (let i = 0; i < checksArray.length; i++) {
        this.ScheduledCheckItems.push({
          ServiceID: checksArray[i][0],
          Type: checksArray[i][1],
          Category: checksArray[i][2],
          ServiceNote: checksArray[i][3],
          EndpointID: checksArray[i][4],
          DeptFloor: checksArray[i][5],
          Position: checksArray[i][6],
          LocationNote: checksArray[i][7],
          ArrangedBy: checksArray[i][8],
          ScheduledDate: checksArray[i][9],
          ScheduledTime: checksArray[i][10],
          AssignedTo: checksArray[i][11],
          Modify: checksArray[i][15],
        });
      }
    });
  },

  methods: {
    acknowledgeTemps() {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/outlets";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "UpdateManualTempCheckStatus",
        DataDict: [
          {
            CheckID: this.detailItem.CheckID,
            Status: "Completed",
          },
        ],
      };

      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          alert("Update Submitted");
          this.$refs["TempDetailsModal"].hide();
          this.resetTables();
        });
    },

    resetTables() {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/outlets";
      let LookUpHeaders = this.$apikeyPost;
      let LookUpRequest = {
        RequestType: "LoadManualTempChecksLocation",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios.post(LookUpUrl, LookUpRequest, LookUpHeaders).then((response) => {
        let CheckResultArray = response.data.Values;
        this.CheckResultItems = [];
        for (let i = 0; i < CheckResultArray.length; i++) {
          this.CheckResultItems.push({
            CheckID: CheckResultArray[i][0],
            OutletID: CheckResultArray[i][1],
            ReadingDate: CheckResultArray[i][2],
            ReadingTime: CheckResultArray[i][3],
            TakenBy: CheckResultArray[i][4],
            HotTemp: CheckResultArray[i][5],
            ColdTemp: CheckResultArray[i][6],
            MixedTemp: CheckResultArray[i][7],
            ReturnTemp: CheckResultArray[i][8],
            Details: "",
          });
        }
      });

      let LookUpUrlComp =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/outlets";
      let LookUpHeadersComp = this.$apikeyPost;
      let LookUpRequestComp = {
        RequestType: "LoadCompletedManualTempChecks",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(LookUpUrlComp, LookUpRequestComp, LookUpHeadersComp)
        .then((response) => {
          this.CheckCompletedResultItems = [];
          let CheckResultArray = response.data.Values;
          for (let i = 0; i < CheckResultArray.length; i++) {
            this.CheckCompletedResultItems.push({
              CheckID: CheckResultArray[i][0],
              OutletID: CheckResultArray[i][1],
              ReadingDate: CheckResultArray[i][2],
              ReadingTime: CheckResultArray[i][3],
              TakenBy: CheckResultArray[i][4],
              HotTemp: CheckResultArray[i][5],
              ColdTemp: CheckResultArray[i][6],
              MixedTemp: CheckResultArray[i][7],
              ReturnTemp: CheckResultArray[i][8],
              Details: "",
            });
          }
        });
    },

    modifyTempBooking(item) {
      this.ModifiedBooking = {};
      this.ModifiedBooking = {
        ServiceID: item.ServiceID,
        Area: item.DeptFloor,
        Description: item.ServiceNote,
        Type: item.Category,
        ArrangedBy: item.ArrangedBy,
        Date: item.ScheduledDate,
        Time: item.ScheduledTime,
        LocationNote: item.LocationNote,
      };

      this.$refs["ModifyTempBookingModal"].show(this.ModifiedBooking);
    },

    viewDetails(item, Status) {
      this.detailItem = item;
      this.checkStatus = Status;
      this.$refs["TempDetailsModal"].show(this.detailItem);
    },
    SubmitTempBooking() {
      let name = localStorage.getItem("fullname");

      if (
        this.newBooking.Room == null ||
        this.newBooking.Name == null ||
        this.newBooking.Date == null ||
        this.newBooking.Email == null ||
        this.newBooking.Time == null ||
        this.newBooking.Number == null
      ) {
        alert("Please complete all fields to submit Booking request");
      } else {
        // let LookUpUrlScheduledTests =
        //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        //   this.$environment +
        //   "/service";
        // let LookUpHeadersScheduledTests = this.$apikeyPost;
        // let LookUpRequestScheduledTests = {
        //   RequestType: "CreateRequest",
        //   RequestVariable: "",
        //   DataDict: [
        //     {
        //       OriginID: "",
        //       Type: "WMS",
        //       Category: "Manual Temp Check",
        //       ServiceNote: "Number of Outlets - " + this.newBooking.Number,
        //       EndpointType: "",
        //       EndpointID: "",
        //       Location: this.selectedlocation,
        //       DeptFloor: this.newBooking.Room,
        //       Position: "",
        //       LocationNote: this.newBooking.Note,
        //       ArrangedBy: name,
        //       ScheduledDate: this.newBooking.Date,
        //       ScheduledTime: this.newBooking.Time,
        //       AssignedTo: "",
        //       ContactName: this.newBooking.Name,
        //       ContactEmail: this.newBooking.Email,
        //       ContactNote: this.newBooking.ContactNote,
        //     },
        //   ],
        // };
        // axios
        //   .post(
        //     LookUpUrlScheduledTests,
        //     LookUpRequestScheduledTests,
        //     LookUpHeadersScheduledTests
        //   )
        //   .then((response) => {
        //     response;
        //     this.$refs["newTempBooking"].hide();
        //     this.resetScheduledChecks();

        //     this.newBooking = {};
        //   });

        name;

        // ToEmail: "Support@seraphprotect.online",

        let EmailService = {
          ToEmail: "Support@seraphprotect.online",

          EmailText:
            "New Appointment Request raised by user.\\n\\n" +
            this.selectedlocation +
            "\\n" +
            this.newBooking.Name +
            "\\n" +
            this.newBooking.Email +
            "\\n" +
            "Note for Contact " +
            this.newBooking.Note +
            "\\n\\n" +
            "Test Information " +
            "\\n\\n" +
            "Test Type" +
            " Manual Temp Check " +
            "\\n" +
            "Room - " +
            this.newBooking.Room +
            "\\n" +
            "Number Of Outlets - " +
            this.newBooking.Number +
            "\\n" +
            "Date and Time - " +
            this.newBooking.Date +
            " at " +
            this.newBooking.Time,

          EmailSubject: "New Test Booking ",
        };

        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";

        let EmailPostHeaders = this.$apikeyPost;

        axios
          .post(EmailPosturl, EmailService, EmailPostHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => {
            "Error: ===", err;
          });
        alert(
          "Your Request has been submitted, A staff member will be in touch."
        );
        // this.resetService();

        // alert("Booking Request has been submitted");
        this.newBooking = {};
      }
    },
    ResetTempBooking() {
      this.newBooking = {};
    },
    SubmitModifiedBooking() {
      // if (
      //   this.ModifiedBooking.Area == "" ||
      //   this.ModifiedBooking.Description == "" ||
      //   this.ModifiedBooking.Type == "" ||
      //   this.ModifiedBooking.ArrangedBy == "" ||
      //   this.ModifiedBooking.Date == "" ||
      //   this.ModifiedBooking.Time == ""
      // ) {
      //   alert("Please complete all fields to submit Booking request");
      // } else {
      //   let LookUpUrl =
      //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      //     this.$environment +
      //     "/service";
      //   let LookUpHeaders = this.$apikeyPost;
      //   this.LookUpRequest = {
      //     RequestType: "ModifyRequest",
      //     RequestVariable: "",
      //     DataDict: [
      //       {
      //         ServiceNote: this.ModifiedBooking.Description,
      //         DeptFloor: this.ModifiedBooking.Area,
      //         LocationNote: this.ModifiedBooking.LocationNote,
      //         ScheduledDate: this.ModifiedBooking.Date,
      //         ScheduledTime: this.ModifiedBooking.Time,
      //         ServiceID: this.ModifiedBooking.ServiceID,
      //       },
      //     ],
      //   };

      //   axios
      //     .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      //     .then((response) => {
      //       response;
      //       alert("Update Submitted");
      //       this.$refs["ModifyTempBookingModal"].hide();
      //       this.resetScheduledChecks();
      //     });
      // }

      if (
        this.ModifiedBooking.Area == "" ||
        this.ModifiedBooking.Description == "" ||
        this.ModifiedBooking.Room == "" ||
        this.ModifiedBooking.Date == "" ||
        this.ModifiedBooking.Time == ""
      ) {
        alert("Please complete all fields to submit Booking request");
      } else {
        let EmailService = {
          ToEmail: "Support@seraphprotect.online",

          EmailText:
            "Modify Appointment Request raised by user.\\n\\n" +
            this.selectedlocation +
            "\\n" +
            this.name +
            "\\n\\n" +
            "Appointment Information " +
            "\\n\\n" +
            this.ModifiedBooking.ServiceID +
            "\\n" +
            "Type - " +
            this.ModifiedBooking.Description +
            "\\n " +
            this.ModifiedBooking.Type +
            "\\n" +
            "Room - " +
            this.ModifiedBooking.Room +
            "\\n" +
            "Area  - " +
            this.ModifiedBooking.Area +
            "\\n" +
            "New Date and Time - " +
            this.ModifiedBooking.Date +
            " at " +
            this.ModifiedBooking.Time,

          EmailSubject: "Service Request Booking Modification ",
        };

        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";

        let EmailPostHeaders = this.$apikeyPost;

        axios
          .post(EmailPosturl, EmailService, EmailPostHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => {
            "Error: ===", err;
          });
        alert(
          "Your Request has been submitted,An Angel Guard staff member will be in touch."
        );

        let ScheduledUpdateURL =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/service";
        let ScheduledUpdateHeaders = this.$apikeyPost;
        let ScheduledUpdateRequest = {
          RequestType: "UpdateService",
          RequestVariable: "",
          DataDict: [
            {
              ServiceID: this.ModifiedBooking.ServiceID,
              Status: "",
              UnderEdit: "TRUE",
            },
          ],
        };
        axios
          .post(
            ScheduledUpdateURL,
            ScheduledUpdateRequest,
            ScheduledUpdateHeaders
          )
          .then((response) => {
            response;
            this.resetScheduledChecks();
          });
        this.$refs["ModifyTempBookingModal"].hide();
      }
    },
    resetScheduledChecks() {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/outlets";
      let LookUpHeaders = this.$apikeyPost;
      let LookUpRequest = {
        RequestType: "LoadManualTempChecksLocation",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios.post(LookUpUrl, LookUpRequest, LookUpHeaders).then((response) => {
        let CheckResultArray = response.data.Values;
        this.CheckResultItems = [];
        for (let i = 0; i < CheckResultArray.length; i++) {
          this.CheckResultItems.push({
            CheckID: CheckResultArray[i][0],
            OutletID: CheckResultArray[i][1],
            ReadingDate: CheckResultArray[i][2],
            ReadingTime: CheckResultArray[i][3],
            TakenBy: CheckResultArray[i][4],
            HotTemp: CheckResultArray[i][5],
            ColdTemp: CheckResultArray[i][6],
            MixedTemp: CheckResultArray[i][7],
            ReturnTemp: CheckResultArray[i][8],
            Details: "",
          });
        }
      });

      let LookUpUrl2 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/outlets";
      let LookUpHeaders2 = this.$apikeyPost;
      let LookUpRequest2 = {
        RequestType: "LoadScheduledManualTempChecks",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(LookUpUrl2, LookUpRequest2, LookUpHeaders2)
        .then((response) => {
          let checksArray = response.data.Values;
          this.ScheduledCheckItems = [];
          for (let i = 0; i < checksArray.length; i++) {
            this.ScheduledCheckItems.push({
              ServiceID: checksArray[i][0],
              Type: checksArray[i][1],
              Category: checksArray[i][2],
              ServiceNote: checksArray[i][3],
              EndpointID: checksArray[i][4],
              DeptFloor: checksArray[i][5],
              Position: checksArray[i][6],
              LocationNote: checksArray[i][7],
              ArrangedBy: checksArray[i][8],
              ScheduledDate: checksArray[i][9],
              ScheduledTime: checksArray[i][10],
              AssignedTo: checksArray[i][11],
              Modify: checksArray[i][15],
            });
          }
        });
    },

    CancelModifiedBooking() {
      this.ModifiedBooking = {};
      this.$refs["ModifyTempBookingModal"].hide();
    },
    showAddNewCheckModal() {
      this.$refs["newTempBooking"].show();
    },
  },
};
</script>

<style></style>
